<template>
  <div class="EntryList">
    <div class="module">
      <title-name :name="'实时入职榜'"></title-name>
      <div class="entry-table">
        <div class="entry-table-item entry-table-head">
          <div class="rc">人才</div>
          <div class="fwkh">服务客户</div>
          <div class="tjzw">推荐职位</div>
          <div class="nx">年薪</div>
          <div class="sj">时间</div>
        </div>
        <div class="entry-table-msg">
          <div class=" entry-table-item" v-for="(item, index) in livelist" :key="index">
              <div class="rc">{{item.customername}}</div>
              <div class="fwkh">{{item.companydisplayname}}</div>
              <div class="tjzw">{{item.jobname}}</div>
              <div class="nx">{{item.factsalary}}</div>
              <div class="sj">{{item.datetime}}</div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <!-- end 实时入职榜 -->
</template>

<script>
import $ from 'jquery'

import {mapGetters, mapActions} from 'vuex'
import TitleName from '../../components/TitleName'
export default {
  name: 'EntryList',
  props: ['livelist'],
  data () {
    return {
      interval: ""  // 滚动
    }
  },
  updated() {
    this.inifAnimated()
  },
  destroyed() {
    clearInterval(this.interval)
  },
  mounted () {
    // $('.entry-table-msg').scrollTop(120)
  },
  methods: {
      inifAnimated() {
        let x = 42, // 初始化的高度
        allx =  0 - parseInt($('.entry-table-msg').height()) + 520// 抵达后需要切换的高度
        this.interval = setInterval(() => {
          if (allx > x) {
            x = 42
          }
          x -= 1
          $('.entry-table-msg').css('bottom', x+"px")
        }, 60)
      },
       ...mapActions([
            'setLoading'
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      TitleName
  }
}
</script>
<style lang="scss">
.EntryList {
  
}
</style>
<style lang="scss" type="text/scss" scoped>
.EntryList {
  padding: 30px 0 40px 0;
  box-sizing: border-box;
  background:rgba(249,249,249,1);

  .entry-table {
    position: relative;
    display: block;
    margin-top: 22px;
    width: 100%;
    height: 520px;
    overflow: hidden;

    .entry-table-head {
      position: relative;
      z-index: 2;
      color: #fff;
      font-size: 14px;
      height:40px;
      line-height: 40px;
      text-align: center;
      background:rgba(46,127,255,1);
      div {
        border-right: solid 1px #fff;
        &:last-child {
          border-right: none;
        }
      }
    }
    .entry-table-item {
      height: 42px;
      line-height: 42px;
      div {
        float: left;
        box-sizing: border-box;
      }
      .rc,
      .nx {
        width: 140px;
      }
      .fwkh {
        width: 390px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tjzw {
        width: 320px;
      }
      .sj {
        width: 210px;
      }

    }
    .entry-table-msg {
      position: absolute;
      bottom: 0;
      // top: 42px;
      .entry-table-item:nth-child(odd) {
        background: #FFFFFF;
      }
      .entry-table-item:nth-child(even) {
        background: #F5F9FF;
      } 
      .entry-table-item {
        color: #2B5278;
        .nx {
          color: #FF7F04;
          text-align: center;
        }
        div {
          padding: 0 20px;
        }
        div:first-child,
        div:last-child {
          text-align: center;
        }
      }
    }
  }
}
</style>